// import CollectionProto from "../../data-structures/depricated/collection-proto"
import ProjectCollectionModel from "./project-collection-model"
import Collection from "../../data-structures/collection";

// export default class ProjectCollectionCollectionSession extends CollectionProto<ProjectCollectionModel> {
//
//     constructor(models:ProjectCollectionModel[]) {
//         super(models, ProjectCollectionModel)
//     }
// }


export default class ProjectCollectionCollectionSession extends Collection<ProjectCollectionModel> {

    constructor(models:ProjectCollectionModel[]) {
        super(models)
    }

    get modelsNotInStructure() {
        return _.filter(this.models, model=>!model.isInStructure)
    }

    resetFromJson(data:JSONArray) {
        const models : ProjectCollectionModel[]   = []
        _.map(data, (record:JSONObject)=>{
            models.push(new ProjectCollectionModel(record))
        })

        return this.reset(models)
    }

    applyDelta(method:string, data:any) {

        switch (method) {
            case 'delete':
                this.remove(data.id);
                break

            case 'new':
                this.add(new ProjectCollectionModel(data));
                break;

            case 'delta':
                const model = this.get(data.id);
                if (model) model.applyDelta(data);
                break;
        }
    }

}